import React from 'react';
const common = require('../common/common');
const ticketCommon = require('../common/ticketCommon.jsx');

class TicketState extends React.Component{
	constructor(props){
    super(props);
    this.state = {};
    this.state.userInfo = {};
    this.state.userInfo.roles = [];
    this.state.marcaDefault = this.state.marcaDefault === undefined ?
      window.cc.marche_attive !== undefined && window.cc.marche_attive.length === 1 ?
        window.cc.marche_attive[0].ZFORN
      :
        common.get_localStorage("valoreMarca")
    :
      this.state.marcaDefault;
	  this.state.actualStates = []
	this.state.folder = this.props.folder
 	}


	UNSAFE_componentWillMount(props){
		const $ = window.$;
		common.getUserInfo().then(userInfo =>{
			this.setState({userInfo: userInfo});
			var statiTicket = [];
			var parametri = {firstTime: true, statiTicket: []};
			if(!window.cc.ticketFirebird){
				if(common.get_localStorage('filtriTickets') !== undefined && common.get_localStorage('filtriTickets').length > 2 && common.get_localStorage('filtriTickets') !== null && common.get_localStorage('filtriTickets') !== '' && common.get_localStorage('filtriTickets') !== undefined){
					statiTicket = JSON.parse(common.get_localStorage('filtriTickets'));
				}else if (userInfo.is_admin_ticket !== undefined && userInfo.is_admin_ticket){
					statiTicket = ['incomplete', 'pending', 'published'];
				}else{
					statiTicket = ['closed', 'incomplete', 'pending',  'published'];
				}
				parametri.statiTicket = statiTicket;
				this.props.onClick("stati_ticket", parametri, true);
				return false;
			}				
			})
		}

	componentDidMount(props){
		if(window.cc.ticketFirebird){
			this.updateIndexedDB()
		}
	}

	changeFilterHandler = () => {
		const $ = window.$;
		//common.add_UX_data(this.state.folder, "Filters", "State_filter", this.state.actualStates);
		this.props.sendData(this.state.actualStates);
	}

	updateIndexedDB() {
		//imposta il primo valore se l'indexedDB è popolato
		const $ = window.$;
		common.get_UX_component(this.state.folder, "Filters", "State_filter").then((states) => {
			if (states !== undefined && states !== null) {
				if (this.state.userInfo.is_admin_ticket !== undefined && this.state.userInfo.is_admin_ticket) {
					var statiTicketSaved = ['incomplete', 'pending', 'published'];
					if (JSON.stringify(states) !== JSON.stringify(statiTicketSaved)) {
						$('#filterDot').css('visibility', 'visible')
					}
				} else {
					var statiTicketSaved = ['closed', 'incomplete', 'pending', 'published'];
					if (JSON.stringify(states) !== JSON.stringify(statiTicketSaved)) {
						$('#filterDot').css('visibility', 'visible')
					}
				}
				this.setState({ actualStates: states}, () => {
					this.changeFilterHandler();
					window.setTimeout(() => {
						window.$(".filtro_stati .filtri").prop('checked', false)
						for (let i = 0; i < states.length; i++) {
							window.$(".filtro_stati .filtri#" + states[i]).prop('checked', true)
						}
					}, 300);
				});
			} else {
				if (this.state.userInfo.is_admin_ticket !== undefined && this.state.userInfo.is_admin_ticket) {
					var statiTicket = ['incomplete', 'pending', 'published'];
				} else {
					var statiTicket = ['closed', 'incomplete', 'pending', 'published'];
				}
				window.$(".filtro_stati .filtri").prop('checked', false)
				this.setState({ actualStates: statiTicket }, () => {
					this.changeFilterHandler();
					window.setTimeout(() => {
						for (let i = 0; i < statiTicket.length; i++) {
							window.$(".filtro_stati .filtri#" + statiTicket[i]).prop('checked', true)
						}
					}, 200);
				});
			}	
		})
	}

	componentDidUpdate(props){
		const $ = window.$;
		if(window.cc.ticketFirebird){
			$('.filtro_stati .filtri').on('click', (e) => {
				var stati = []	
				var checkboxes = $('#filtro_stati input[type="checkbox"]:checked');
				checkboxes.each(function () {
					var valoreCheckbox = $(this).val();
					stati.push(valoreCheckbox)
				})
				this.state.actualStates = stati.sort()
				this.changeFilterHandler();

				if(this.state.userInfo.is_admin_ticket){
					var statiTicket = ['incomplete', 'pending', 'published'];
				}else{
					var statiTicket = ['closed', 'incomplete', 'pending', 'published'];
				}
				if (JSON.stringify(stati.sort()) !== JSON.stringify(statiTicket.sort())){
					$('#filterDot').css('visibility', 'visible')
				}else{
					$('#filterDot').css('visibility', 'hidden')
				}
			})
		}
	}

	render(props){
		return (
			<>
				<div className="col-md-12 col-sm-12 col-xs-12 row-eq-height">
	        <div className="col-12 p-0 filtro_stati">
						{window.cc.ticketFirebird ?
							<p>{common.getTrad("Filtra per stati")} <span id="filterDot" className="orange-dot" style={{ visibility: 'hidden', position: 'absolute', left: '-9px', top: '7px'}}></span></p>
						:
						<p>{common.getTrad("Filtra per stati")}</p>
						}
						{this.state.title}
	          <div className="form-group">
		 					<div className="c-inputs-stacked" id="filtro_stati">
								<div className="d-inline-block custom-control custom-checkbox mr-3 mb-3">
									<input onClick={() => this.props.onClick("stati_ticket", {statiTicket: "pending"}, false)} type="checkbox" name="pending" value="pending" className="custom-control-input filtri" data-stato="pending" id="pending" />
									<label className="custom-control-label" htmlFor="pending">
									<span style={{background: "#28a745", boxShadow:"1px 1px 3px -1px #000", padding: "0.25em 0.5em",color: "#fff"}}><i className="fas fa-envelope-open-text"></i> {common.getTrad("Ticket Aperti")}</span>
									</label>
								</div>
								<div className="d-inline-block custom-control custom-checkbox mr-3 mb-3">
									<input onClick={() => this.props.onClick("stati_ticket", {statiTicket: "published"}, false)} type="checkbox" name="published" value="published" className="custom-control-input filtri" data-stato="published" id="published" />
									<label className="custom-control-label" htmlFor="published">
										<span style={{background: "#007bff", boxShadow:"1px 1px 3px -1px #000", padding: "0.25em 0.5em",color: "#fff"}}><i className="fas fa-envelope"></i> {common.getTrad("Ticket In lavorazione")}</span>
									</label>
								</div>
								<div className="d-inline-block custom-control custom-checkbox mr-3 mb-3">
									<input onClick={() => this.props.onClick("stati_ticket", {statiTicket: "incomplete"}, false)} type="checkbox" name="incomplete" value="incomplete" className="custom-control-input filtri" data-stato="incomplete" id="incomplete" />
									<label className="custom-control-label" htmlFor="incomplete">
										<span style={{background: "#ffc107", boxShadow:"1px 1px 3px -1px #000", padding: "0.25em 0.5em",color: "#000"}}><i className="fas fa-envelope-open"></i> {common.getTrad("Ticket Incompleti")}</span>
									</label>
								</div>
								<div className="d-inline-block custom-control custom-checkbox mb-3">
									<input onClick={() => this.props.onClick("stati_ticket", {statiTicket: "closed"}, false)} type="checkbox" name="closed" className="custom-control-input filtri" value="closed" data-stato="closed"  id="closed"/>
									<label className="custom-control-label" htmlFor="closed">
									<span style={{background: "#dc3545", boxShadow:"1px 1px 3px -1px #000", padding: "0.25em 0.5em",color: "#fff"}}><i className="fas fa-envelope"></i> {common.getTrad("Ticket Chiusi")}</span>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
    )
  }
}

export default TicketState;
